const CURRENT_USER_KEY: string = 'current_user';

export interface Privileges {
  isCourtManager: boolean;
  isOpeningManager: boolean;
  isCourtMonitoringManager: boolean;
  isConsultationManager: boolean;
  isTransactionManager: boolean;
  isJudgementArchiveManager: boolean;
  isPriorityClaimsManager: boolean;
}

export interface CurrentUser {
  username: string;
  privileges: Privileges;
  subservices: {};
}

const get = (): CurrentUser => {
  try {
    return JSON.parse(`${window.localStorage.getItem(CURRENT_USER_KEY)}`);
  } catch (error) {
    return {} as CurrentUser;
  }
};

const set = (currentUser: CurrentUser) =>
  window.localStorage.setItem(CURRENT_USER_KEY, JSON.stringify(currentUser));

const clear = () => window.localStorage.removeItem(CURRENT_USER_KEY);

const currentUserStorage = {
  get,
  set,
  clear,
};

export default currentUserStorage;
